export default __webpack_public_path__ + "static/media/Forging-Vendors.3a492118.jpg";